import {ControlElement} from "@jsonforms/core";

export const allControl: ControlElement = {
  scope: "#",
  type: "Control"
};
